import type { ReactNode } from 'react';
import { forwardRef } from 'react';

import { ChartCard } from './ChartCard';
import { StyledChartCardWrapper } from './styles';

type ChartCardWithRefProps = {
  title: ReactNode;
  date?: ReactNode;
  countryCode?: number;
  compact?: boolean;
  withBorder?: boolean;
  extendedFooterPadding?: boolean;
  children: ReactNode;
  dataAutomation?: string;
};

export const ChartCardWithRef = forwardRef<HTMLDivElement, ChartCardWithRefProps>(
  ({ title, date, countryCode, compact, withBorder, extendedFooterPadding, children, dataAutomation }, ref) => {
    return (
      <StyledChartCardWrapper ref={ref} compact={compact} data-automation={dataAutomation}>
        <ChartCard
          title={title}
          date={date}
          countryCode={countryCode}
          withBorder={withBorder}
          extendedFooterPadding={extendedFooterPadding}
        >
          {children}
        </ChartCard>
      </StyledChartCardWrapper>
    );
  }
);
